var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'sys-checkbox',
        _vm.size && ("normal-" + _vm.size),
        {
            checked: _vm.checked,
        } ],on:{"click":function($event){return _vm.$emit('click', !_vm.checked)}}},[_c('span',{staticClass:"sys-checkbox__icon"},[_c('CheckIcon')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }